export default __webpack_public_path__ + "static/PS-licence-24ad6e793ca9d16d46fc60e4bacfba5e.png";